
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector(".follow-us");
  const slidesArray = JSON.parse(section.getAttribute('data-slides'));
  const slideData = slidesArray.flat();

  let currentSlideIndexFollowUs = localStorage.getItem('currentSlideIndexFollowUs')
      ? parseInt(localStorage.getItem('currentSlideIndexFollowUs'))
      : 0;

  const slideCount = 10;

  function appendSlides(swiperInstance) {
      swiperInstance.removeAllSlides();

      for (let i = 0; i < slideCount; i++) {
          let slideHtml = `
          <div class="swiper-slide">
            ${slideData[(currentSlideIndexFollowUs + i) % slideData.length].image}
          </div>
      `;

          swiperInstance.appendSlide(slideHtml);
      }
      
      localStorage.setItem('currentSlideIndexFollowUs', (currentSlideIndexFollowUs + slideCount) % slideData.length);
  }

  const swiperFollowUs = new Swiper('.follow-us__swiper', {
      slidesPerView: 2.2,
      spaceBetween: 2,
      loop: true,
      watchOverflow: true,
      breakpoints: {
          1130: {
              slidesPerView: "auto"
          },
          900: {
              slidesPerView: 4.5
          },
          768: {
              slidesPerView: 3.7
          },
          600: {
              slidesPerView: 2.7
          }
      },
      autoplay: {
          delay: 4000,
          disableOnInteraction: false
      },
      navigation: {
          nextEl: '.press-swiper__next',
          prevEl: '.press-swiper__prev'
      },
      on: {
          init: (swiper) => {
              appendSlides(swiper);
          }
      }
  });
});